// Lot projections (findings #82): office settings kept in `metadata`
// (no migration).
//
// - `Lot.metadata.harvestTargetWeightG`  target harvest weight for the lot (g)
// - `Farm.metadata.harvestTargetWeightG` facility default when a lot has none
// - `Farm.metadata.projectionTgc`        facility TGC used when a lot has only
//                                        one sampling (e.g. 2.5)

type WithMetadata = { metadata?: Record<string, unknown> | null } | null | undefined

const readMetadata = (value: WithMetadata): Record<string, unknown> => {
  const metadata = value?.metadata
  return metadata && typeof metadata === 'object' && !Array.isArray(metadata) ? metadata : {}
}

const positive = (value: unknown): number | null => {
  const parsed = typeof value === 'number' ? value : Number(value)
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null
}

export const readHarvestTargetWeightG = (value: WithMetadata): number | null =>
  positive(readMetadata(value).harvestTargetWeightG)

export const readProjectionTgc = (value: WithMetadata): number | null =>
  positive(readMetadata(value).projectionTgc)

export const withHarvestTargetWeightG = <T extends NonNullable<WithMetadata>>(value: T, grams: number | null): T => {
  const metadata = { ...readMetadata(value) }
  if (grams === null) delete metadata.harvestTargetWeightG
  else metadata.harvestTargetWeightG = grams
  return { ...value, metadata }
}

export const withProjectionTgc = <T extends NonNullable<WithMetadata>>(value: T, tgc: number | null): T => {
  const metadata = { ...readMetadata(value) }
  if (tgc === null) delete metadata.projectionTgc
  else metadata.projectionTgc = tgc
  return { ...value, metadata }
}
